import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
import { useFieldContext } from '../Field';
export const useLabelClasses = ({ className, floatingLabel = true }) => {
    return floatingLabel
        ? cx('absolute top-2 flex flex-1 translate-y-0 items-center ltr:ml-3 ltr:mr-8 ltr:text-left rtl:ml-8 rtl:mr-3 rtl:text-right', 'bg-transparent text-xs font-normal leading-none text-gray-700 transition-all', 'peer-focus:top-2 peer-focus:translate-y-0 peer-focus:text-xs peer-focus:leading-none', 'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-placeholder-shown:leading-none peer-placeholder-shown:text-gray-700', 'cursor-pointer', className)
        : className;
};
const LabelComponent = forwardRef(({ className, ...rest }, ref) => {
    const { floatingLabel } = useFieldContext();
    const classes = useLabelClasses({ className, floatingLabel });
    return _jsx(HeadlessField.Label, { ref: ref, className: classes, ...rest });
});
LabelComponent.displayName = 'Label';
const Label = LabelComponent;
export { Label };
//# sourceMappingURL=Label.js.map